import React, { useMemo } from 'react'
import T from 'prop-types'
import { Box, Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  CAR_CHOICE_ACCEPTED,
  CAR_CHOICE_ACCEPTED_WITH_REPRICE,
} from 'lib/carChoicesLib'

import ChoiceRecap from 'components/atoms/ChoiceRecap'
import FilterSelect from 'components/atoms/FilterSelect'

import {
  FILTER_ASSIGNMENT_CHOICES_ACCEPTED_CHOICE,
  FILTER_ASSIGNMENT_CHOICES_NONE_CHOICE,
  FILTER_ASSIGNMENT_CHOICES_NOT_CHOSEN,
  FILTER_ASSIGNMENT_CHOICES_ACCEPTED_WITH_REPRICE_CHOICE,
  FILTER_ASSIGNMENT_TYPE_NONE_CHOICE,
  FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE,
  FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE,
  FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE,
} from 'hooks/useCarsFilters'

import { getAssignmentRecapValues } from '../Assignment/assignmentLib'

export default function AssignmentChoicesRecap({
  cars = [],
  filters,
  filtersData,
  setAssignmentPartners,
  setFilteringChoice,
  setAssignmentType,
}) {
  const { t } = useTranslation()

  const choices = useMemo(
    () =>
      getAssignmentRecapValues(
        cars,
        filters.assignmentPartners !== t('common.form.all')
          ? filters.assignmentPartners
          : undefined
      ),
    [cars, filters.assignmentPartners, t]
  )

  return (
    <>
      <Stack
        direction="row"
        flexWrap="wrap"
        data-testid="assignment-choice-recap"
      >
        <FilterSelect
          allOption={{ label: t('common.form.all'), value: '' }}
          options={filtersData.assignmentPartners}
          value={filters.assignmentPartners}
          hideCheckBox
          handleChange={setAssignmentPartners}
          sx={{ width: '15ch' }}
          selectProps={{ displayEmpty: true }}
        />

        <Box pr={2} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <Box pr={2} />

        <ChoiceRecap
          id="total"
          title={t('assignment.car-assignment.labelTitle.allCars')}
          value={choices.total}
          handleClick={() =>
            setFilteringChoice(FILTER_ASSIGNMENT_CHOICES_NONE_CHOICE)
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={CAR_CHOICE_ACCEPTED}
          title={t(
            `assignment.car-assignment.labelTitle.${CAR_CHOICE_ACCEPTED}`
          )}
          value={choices[CAR_CHOICE_ACCEPTED]}
          handleClick={() =>
            setFilteringChoice(FILTER_ASSIGNMENT_CHOICES_ACCEPTED_CHOICE)
          }
          selected={
            filters.assignmentCaps === FILTER_ASSIGNMENT_CHOICES_ACCEPTED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={CAR_CHOICE_ACCEPTED_WITH_REPRICE}
          title={t('assignment.car-assignment.labelTitle.acceptedWithReprice')}
          value={choices[CAR_CHOICE_ACCEPTED_WITH_REPRICE]}
          handleClick={() =>
            setFilteringChoice(
              FILTER_ASSIGNMENT_CHOICES_ACCEPTED_WITH_REPRICE_CHOICE
            )
          }
          selected={
            filters.assignmentCaps ===
            FILTER_ASSIGNMENT_CHOICES_ACCEPTED_WITH_REPRICE_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id="notChosen"
          title={t('assignment.car-assignment.labelTitle.notChosen')}
          value={choices.notChosen}
          handleClick={() =>
            setFilteringChoice(FILTER_ASSIGNMENT_CHOICES_NOT_CHOSEN)
          }
          selected={
            filters.assignmentCaps === FILTER_ASSIGNMENT_CHOICES_NOT_CHOSEN
          }
          border
        />

        <Box pr={2} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <Box pr={2} />

        <ChoiceRecap
          id="allCars"
          title={t('assignment.car-assignment.labelTitle.allCars')}
          value={choices.total}
          handleClick={() =>
            setAssignmentType(FILTER_ASSIGNMENT_TYPE_NONE_CHOICE)
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE}
          title={t(
            `assignment.car-assignment.labelTitle.${FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE}`
          )}
          value={choices[FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE]}
          handleClick={() =>
            setAssignmentType(FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE)
          }
          selected={
            filters.assignmentType === FILTER_ASSIGNMENT_TYPE_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE}
          title={t(
            `assignment.car-assignment.labelTitle.${FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE}`
          )}
          value={choices[FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE]}
          handleClick={() =>
            setAssignmentType(FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE)
          }
          selected={
            filters.assignmentType ===
            FILTER_ASSIGNMENT_TYPE_NOT_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE}
          title={t(
            `assignment.car-assignment.labelTitle.${FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE}`
          )}
          value={choices[FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE]}
          valueProps={{
            color: choices[FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE]
              ? 'error'
              : undefined,
          }}
          handleClick={() =>
            setAssignmentType(FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE)
          }
          selected={
            filters.assignmentType ===
            FILTER_ASSIGNMENT_TYPE_TO_BE_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
      </Stack>
    </>
  )
}

AssignmentChoicesRecap.propTypes = {
  cars: T.array,
  setFilteringChoice: T.func,
  setAssignmentType: T.func,
  readOnly: T.bool,
}
